import { Text } from '@chakra-ui/react'
import React from 'react'
import styled from 'styled-components'
import MultiFillSlider, { FillValues } from '~/components/MultiFillSlider'
import { colorPalette } from '~/themes/colors/colorPalette'
import { textStyleKeys } from '~/themes/textStyles'
import { CallTranscript } from '~/types/CallTranscript'

interface OfficeSentimentSliderWrapperProps {
  margin?: string
}
const OfficeSentimentSliderWrapper = styled.div<OfficeSentimentSliderWrapperProps>`
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.margin ?? 'none'};
`

interface SentimentSliderProps {
  callTranscript: CallTranscript
  participantRole: 'AGENT' | 'CUSTOMER'
  margin?: string
}

export const SentimentSlider = ({
  callTranscript,
  margin,
  participantRole,
}: SentimentSliderProps) => {
  const getSentimentColor = (sentiment: string) => {
    switch (sentiment) {
      case 'POSITIVE':
        return colorPalette.green[600]
      case 'NEGATIVE':
        return colorPalette.red[700]
      default:
        return colorPalette.gray[700]
    }
  }

  const getSentimentTooltipText = (sentiment: string) => {
    switch (sentiment) {
      case 'POSITIVE':
        return 'Positive'
      case 'NEGATIVE':
        return 'Negative'
      case 'NEUTRAL':
        return 'Neutral'
      default:
        return colorPalette.gray[700]
    }
  }

  const sentimentEntry =
    callTranscript.Transcript.filter((t) => {
      return t.ParticipantRole === participantRole
    }).map((transcriptEntry) => {
      const callDuration =
        callTranscript.ConversationCharacteristics
          .TotalConversationDurationMillis
      return {
        startPercentage: transcriptEntry.BeginOffsetMillis / callDuration,
        endPercentage: transcriptEntry.EndOffsetMillis / callDuration,
        fillProps: {
          fillColor: getSentimentColor(transcriptEntry.Sentiment),
          fillHeight: 6,
          fillBorderRadius: 0,
        },
        tooltipText: getSentimentTooltipText(transcriptEntry.Sentiment),
      } as FillValues
    }) ?? []

  return (
    <OfficeSentimentSliderWrapper margin={margin}>
      <Text
        textStyle={textStyleKeys.body3}
        fontSize="12px"
        color={colorPalette.gray[700]}
      >
        {participantRole === 'AGENT' ? 'Office' : 'Patient'}
      </Text>
      <MultiFillSlider
        height={6}
        backgroundColor={colorPalette.gray[400]}
        width="100%"
        animate
        fillValues={sentimentEntry}
      />
    </OfficeSentimentSliderWrapper>
  )
}
